module.exports = __webpack_public_path__ + "img/warning-amber-black-24-dp.4495e473.svg";